import * as types from './constants';

export const initialState = {
  listData: {
    list: [],
    loading: false,
    count: 0,
    next: null,
    previous: null,
    curr_page: 1,
    errors_api: {},
    message: null
  }
};

const actions = {

  // Get Performance Tags
  [types.GET_PERFORMANCE_TAGS_REQUEST]: state => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: true
      }
    };

    return { ...data };
  },

  [types.GET_PERFORMANCE_TAGS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: false,
        list: payload.results
      }
    };

    return { ...data };
  },

  [types.GET_PERFORMANCE_TAGS_FAILED]: state => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: false
      }
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

